import { Divider } from '@material-ui/core';
import React from 'react';

const CustomDivider: React.FC = () => (
  <Divider
    style={{
      height: '2px',
      padding: 0,
      marginLeft: '8px',
      marginRight: '8px',
    }}
  />
);

export default CustomDivider;
